import React, { useEffect, useState, useRef } from "react";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import { viewCardDetailsApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";

export const SuccessStep = ({ setStep, iframeSrc: iframeSrcProp }) => {
  const { showLoader, hideLoader } = useLoader();
  const [iframeSrc, setIframeSrc] = useState(iframeSrcProp ?? "");
  const fetched = useRef(false);

  // When no iframe from parent (e.g. came from SMS form, !sca_access), fetch once.
  useEffect(() => {
    if (iframeSrcProp) {
      setIframeSrc(iframeSrcProp);
      return;
    }
    if (fetched.current) return;
    fetched.current = true;
    const card_id = drupalSettings?.card_id;
    const connected_account_id = drupalSettings?.connected_account_id;
    if (!card_id || !connected_account_id) return;
    showLoader();
    viewCardDetailsApi({ card_id, connected_account_id })
      .then((data) => {
        if (data?.iframe_src) setIframeSrc(data.iframe_src);
        hideLoader();
      })
      .catch(() => hideLoader());
  }, [iframeSrcProp]);

  const handleIframeLoad = () => {
    setTimeout(() => hideLoader(), 1000);
  };

  return (
    <>
      <div className="popup-header">
        <h4 className="popup-title">
          {Drupal.t("Here's Your Full Card Details")}
        </h4>
      </div>

      <div className="popup-body-content">
        {iframeSrc ? (
          <iframe src={iframeSrc} onLoad={handleIframeLoad} />
        ) : (
          <p style={{ textAlign: "center" }}>
            {Drupal.t("Loading your Card Details ... ")}
          </p>
        )}

        <img
          className={"nz-card-img"}
          src="/themes/custom/naut_zero/assets/mycard/nz-card.png"
        />

        <div className="popup-description">
          <p>
            Don't forget to add your card to your phone's digital wallet for
            quick and easy spending on-the-go.
          </p>
        </div>
      </div>
    </>
  );
};
